
import { defineComponent } from "vue";
import { useStore } from "vuex";
import styleUtils from '@/utils/style';
import GenericButton from "../shared/GenericButton.vue";
import GenericPanel from "../shared/GenericPanel.vue";

export default defineComponent({
    name: "SPECIAL",
    setup() {
        const store = useStore();
        const desc = [
            "Very Bad",
            "Bad",
            "Poor",
            "Fair",
            "Average",
            "Good",
            "Very Good",
            "Great",
            "Excellent",
            "Heroic",
        ];
        const showInfo = (category: string, stat: string) => {
            store.dispatch('handleIncomingCommand', {
                command: 'updateInfoPanel',
                data: { category, stat }
            });
        };
        const modifySPECIAL = (modifier: string, statName: string) => {
            showInfo("SPECIAL", statName);
            store.dispatch('handleIncomingCommand', {
                command: 'modifySpecial',
                data: { modifier, statName }
            });
        };
        const getStatData = (stat: string) => {
            const statValue = store.state.build.SPECIAL[stat].value;
            const data = {
                value: statValue,
                desc: desc[statValue - 1],
                color: styleUtils.calculateSuccessClass(statValue),
            };
            return data;
        };
        return {
            state: store.state,
            SPECIAL: store.state.build.SPECIAL,
            modifySPECIAL,
            showInfo,
            getStatData,
        };
    },
    components: { GenericButton, GenericPanel }
});
